(function () {
  function validate(context) {
    var typeId = context === 'drawer' ? 'cart-drawer-delivery-type' : 'cart-delivery-type';
    var liftgateId = context === 'drawer' ? 'cart-drawer-liftgate' : 'cart-liftgate';
    var deliveryType = document.getElementById(typeId);
    var liftgate = document.getElementById(liftgateId);
    return deliveryType && liftgate && deliveryType.value !== '' && liftgate.value !== '';
  }

  function showError(errorId, fieldsId) {
    var errorMsg = document.getElementById(errorId);
    var fieldsWrap = document.getElementById(fieldsId);
    if (errorMsg) errorMsg.style.display = 'block';
    if (fieldsWrap) fieldsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideError(errorId) {
    var errorMsg = document.getElementById(errorId);
    if (errorMsg) errorMsg.style.display = 'none';
  }

  function submitDrawerCart() {
    var deliveryType = document.getElementById('cart-drawer-delivery-type');
    var liftgate = document.getElementById('cart-drawer-liftgate');
    var note = document.getElementById('cart-drawer-notes');

    var data = {
      attributes: {
        'Delivery Type': deliveryType ? deliveryType.value : '',
        'Liftgate Requirement': liftgate ? liftgate.value : ''
      }
    };
    if (note) data.note = note.value;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('cart update failed:', err);
      });
  }

  // Delegated click handler — catches both drawer and cart page checkout buttons,
  // works even after Dawn re-renders the drawer contents via Ajax
  document.body.addEventListener('click', function (e) {
    var target = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (!target) return;

    if (target.id === 'CartDrawer-Checkout') {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!validate('drawer')) {
        showError('cart-drawer-delivery-error', 'cart-drawer-delivery-fields');
        return;
      }
      submitDrawerCart();
    } else if (target.id === 'checkout') {
      if (!validate('cart')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError('cart-delivery-error', 'cart-delivery-fields');
      }
    }
  }, true);

  // Fallback: also block native form submit on the regular cart page
  document.body.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'cart') {
      if (!validate('cart')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError('cart-delivery-error', 'cart-delivery-fields');
      }
    }
  }, true);

  // Delegated change handler — hides errors when fields are filled in,
  // works even if the drawer's dropdowns get re-rendered
  document.body.addEventListener('change', function (e) {
    var id = e.target.id;
    if (id === 'cart-drawer-delivery-type' || id === 'cart-drawer-liftgate') {
      if (validate('drawer')) hideError('cart-drawer-delivery-error');
    } else if (id === 'cart-delivery-type' || id === 'cart-liftgate') {
      if (validate('cart')) hideError('cart-delivery-error');
    }
  });
})();